import React from "react";
import SearchDrawer from "./SearchDrawer";

export default class SearchResult extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTimer: null,
      hoveredIn: false,
      drawerOpen: false,
      overlayVisible: false,
      clickedArticleAnchor: false,
    };

    this.onToggleDrawer = this.onToggleDrawer.bind(this);
    this.onOpenPath = this.onOpenPath.bind(this);
    this.onIgnore = this.onIgnore.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onTouchEndArticleAnchor = this.onTouchEndArticleAnchor.bind(this);
  }

  componentDidMount() {
    var self = this;
    $(window).on(`scroll.${self.props.id}`, function () {
      clearTimeout(self.state.scrollTimer);
      var scrollTimer = setTimeout(function () {
        self.setState({ scrollTimer: null });
      }, 250);
      self.setState({ scrollTimer: scrollTimer });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resultOverlay != this.props.id) {
      this.setState({ hoveredIn: false, overlayVisible: false });
    }
  }

  render() {
    return (
      <div
        className={
          "search-result " +
          this.generateCourseIdClasses() +
          this.props.size +
          " " +
          (this.state.hoveredIn ? "hoveredIn" : "")
        }
        onTouchEnd={this.onTouchEnd}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {this.renderCheckbox()}
        {this.renderPreviewImage()}
        {this.renderName()}
        {/*this.renderLocation()*/}
        {/*this.renderType()*/}
        {/*this.renderLastModified()*/}
        {/*this.renderActionEllipsis()*/}
        {this.renderOverlay()}
        {/*<SearchDrawer
          {...this.props}
          open={this.state.drawerOpen}
          onToggleDrawer={this.onToggleDrawer}
        />*/}
        <div
          className={
            "search-drawer-background " + (this.state.drawerOpen && "visible")
          }
          onClick={this.onToggleDrawer}
        >
          &nbsp;
        </div>
      </div>
    );
  }

  renderActionEllipsis() {
    return (
      <div className="action-ellipsis" tabIndex={0} onKeyDown={this.onTouchEnd}>
        <div className="value">
          <span className="fa fa-ellipsis-h"></span>
        </div>
      </div>
    );
  }

  renderCheckbox() {
    return (
      <div className="checkbox-col">
        <div className="value"> </div>
      </div>
    );
  }

  renderLastModified() {
    return (
      <div className="last-modified">
        <div className="value">{this.props.updated_at}</div>
      </div>
    );
  }

  renderLocation() {
    if (this.props.location && this.props.location_count == 1) {
      return (
        <div className="location">
          <div
            className="value"
            dangerouslySetInnerHTML={{ __html: this.props.location.name }}
          ></div>
        </div>
      );
    } else if (this.props.location) {
      return (
        <div className="location">
          <div
            className="value"
            dangerouslySetInnerHTML={{
              __html: `${this.props.location.name} + ${
                this.props.location_count - 1
              }`,
            }}
          ></div>
        </div>
      );
    } else {
      return (
        <div className="location">
          <div className="value"> </div>
        </div>
      );
    }
  }

  renderName() {
    return (
      <div className="name">
        <a
          href={this.props.path}
          className="value article-anchor"
          onTouchEnd={this.onTouchEndArticleAnchor}
        >
          <div
            className="content article-anchor"
            dangerouslySetInnerHTML={{ __html: this.props.name }}
          ></div>
          <div
            className="collection"
            dangerouslySetInnerHTML={{
              __html: this.props.course_collections[0].name,
            }}
          ></div>
        </a>
      </div>
    );
  }

  renderOverlay() {
    return (
      <div className="overlay" style={{ display: "flex" }}>
        {/*<div
          className="overlay-button primary"
          tabIndex={0}
          role="button"
          aria-label="Preview course popup button"
          onClick={this.onToggleDrawer}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              this.onToggleDrawer();
            }
          }}
        >
          Preview
        </div>*/}
        <a ref="path_link" href={this.props.path} className="overlay-button">
          Open
        </a>
      </div>
    );
  }

  renderPreviewImage() {
    return (
      <a
        href={this.props.path}
        className="preview-image article-anchor"
        onTouchEnd={this.onTouchEndArticleAnchor}
      >
        <img
          src={this.props.image_preview_path}
          alt={`Preview image for ${this.props.name}`}
          className="article-anchor"
        />
      </a>
    );
  }

  renderType() {
    return (
      <div className="type">
        <div className="value">{this.props.type}</div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onToggleDrawer(e) {
    var self = this;

    if (
      e &&
      typeof e.stopPropagation === "function" &&
      typeof e.preventDefault === "function"
    ) {
      e.stopPropagation();
      e.preventDefault();
    }

    this.setState({ drawerOpen: !this.state.drawerOpen }, function () {
      if (self.state.drawerOpen) {
        $("html, body").addClass("noscroll");
      } else {
        $("html, body").removeClass("noscroll");
      }
    });
  }

  onOpenPath() {
    $(this.refs.path_link).trigger("click");
  }

  onIgnore(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onTouchEndArticleAnchor(e) {
    this.setState({
      clickedArticleAnchor: true,
      overlayVisible: false,
      hoveredIn: false,
    });
    e.stopPropagation();
  }

  onTouchEnd(e) {
    var self = this;
    var $target = $(e.target);

    if (
      $target.hasClass("overlay-button") ||
      this.state.clickedArticleAnchor ||
      this.state.drawerOpen ||
      this.state.scrollTimer
    ) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (!this.state.hoveredIn || !this.state.overlayVisible) {
      this.setState({ overlayVisible: true, hoveredIn: true }, function () {
        self.props.onShowResultOverlay(self.props.id);
      });
    } else {
      this.setState({ overlayVisible: false, hoveredIn: false });
    }
  }

  onMouseEnter(e) {
    e.stopPropagation();
    e.preventDefault();
    if (this.state.clickedArticleAnchor) {
      this.setState({ clickedArticleAnchor: false });
      return;
    }
    this.setState({ overlayVisible: true, hoveredIn: true });
  }

  onMouseLeave(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.state.clickedArticleAnchor) {
      this.setState({ clickedArticleAnchor: false });
      return;
    }
    this.setState({ overlayVisible: false, hoveredIn: false });
  }

  /**
   * Helper functions
   */

  generateCourseIdClasses() {
    var ids = [];
    for (var i = 0, ilen = this.props.courses.length; i < ilen; i++) {
      ids.push("course-" + this.props.courses[i].public_id);
    }
    return ids.join(" ") + " ";
  }
}
